import { render, staticRenderFns } from "./downloadTest.vue?vue&type=template&id=49c16d13&scoped=true&"
import script from "./downloadTest.vue?vue&type=script&lang=js&"
export * from "./downloadTest.vue?vue&type=script&lang=js&"
import style0 from "./downloadTest.vue?vue&type=style&index=0&id=49c16d13&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c16d13",
  null
  
)

export default component.exports